import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import styled from 'styled-components';
import { HaveAnAccountLink } from '../step-landing-page/HaveAnAccountLink';
import { devices } from '../styles/viewports.styles';
import { BackLink } from '../views-components/BackLink';
import HubSpotLogo from '../views-components/HubSpotLogo';
import { ProgressIndicator } from '../views-components/ProgressIndicator';
export const Header = styled.div.withConfig({
  displayName: "AppHeader__Header",
  componentId: "sc-9ifaky-0"
})(["grid-column-start:2;grid-column-end:span 3;display:flex;justify-content:space-between;align-items:center;margin:1rem 0;@media ", "{margin:8px;align-items:center;}"], devices.desktop);
const Logo = styled.div.withConfig({
  displayName: "AppHeader__Logo",
  componentId: "sc-9ifaky-1"
})(["order:1;@media ", "{margin-top:1rem;order:initial;}"], devices.desktop);
const AccountSelector = styled.div.withConfig({
  displayName: "AppHeader__AccountSelector",
  componentId: "sc-9ifaky-2"
})(["@media ", "{.BackLink{display:none;}}"], devices.desktop);
export const AppHeader = () => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ProgressIndicator, {}), /*#__PURE__*/_jsxs(Header, {
      children: [/*#__PURE__*/_jsx(Logo, {
        children: /*#__PURE__*/_jsx(HubSpotLogo, {})
      }), /*#__PURE__*/_jsxs(AccountSelector, {
        children: [/*#__PURE__*/_jsx(HaveAnAccountLink, {}), /*#__PURE__*/_jsx(BackLink, {})]
      })]
    })]
  });
};